export default __webpack_public_path__ + "static/media/1645.108ab4ae.png";